import React from "react";
import { TimezoneSelectorProps } from "./types";
import { TimezonesService } from "@/utils/timezoneHelper";
import { Select } from "@npm_leadtech/qr-ui-components";

const timezones = TimezonesService.timezones;

export function TimezoneSelector({
  placeholder,
  label,
  value,
  onChange,
  searchPlaceholder,
  className,
}: TimezoneSelectorProps) {
  return (
    <div className={className}>
      <Select
        multiple={false}
        searchable
        placeholder={placeholder}
        label={label}
        value={value}
        onChange={onChange}
        searchInputPlaceholder={searchPlaceholder}
        options={timezones.map((tz) => ({
          value: tz.timezone,
          label: tz.displayName,
        }))}
      />
    </div>
  );
}
